import { render } from "./items-table.vue?vue&type=template&id=07794ed0"
import script from "./items-table.vue?vue&type=script&lang=js"
export * from "./items-table.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__